import { InjectionToken, NgModule } from "@angular/core";
import {
  Routes,
  RouterModule,
  ExtraOptions,
  ActivatedRouteSnapshot,
} from "@angular/router";

import { HomeComponent } from "./pages/home/home.component";
import { WorkComponent } from "./pages/work/work.component";
import { ServicesComponent } from "./pages/services/services.component";
import { ContactComponent } from "./pages/contact/contact.component";
import { WorkListComponent } from "./shared/blocks/work-list/work-list.component";
import { VittaaAppComponent } from "./pages/vittaa-app/vittaa-app.component";
import { KatWebsiteComponent } from "./pages/kat-website/kat-website.component";
import { Danvi2Component } from "./pages/danvi2/danvi2.component";
import { OndergrondsverbondComponent } from "./pages/ondergrondsverbond/ondergrondsverbond.component";
import { AureaComponent } from "./pages/aurea/aurea.component";

const externalUrlProvider = new InjectionToken("externalUrlRedirectResolver");
const deactivateGuard = new InjectionToken("deactivateGuard");

export const routes: Routes = [
  { path: "", component: HomeComponent },
  { path: "home", pathMatch: "full", component: HomeComponent },
  { path: "work", pathMatch: "full", component: WorkComponent },
  { path: "random", pathMatch: "full", component: WorkComponent },
  { path: "work-list", pathMatch: "full", component: WorkListComponent },

  { path: "services", pathMatch: "full", component: ServicesComponent },
  { path: "contact", pathMatch: "full", component: ContactComponent },
  { path: "vittaa-app", pathMatch: "full", component: VittaaAppComponent },
  { path: "kat-website", pathMatch: "full", component: KatWebsiteComponent },
  { path: "danvi2", pathMatch: "full", component: Danvi2Component },
  { path: "aurea", pathMatch: "full", component: AureaComponent },
  {
    path: "ondergrondsverbond",
    pathMatch: "full",
    component: OndergrondsverbondComponent,
  },

  {
    path: "externalRedirect",
    canActivate: [externalUrlProvider],
    component: HomeComponent,
  },

  { path: "**", component: HomeComponent },
];

const routerOptions: ExtraOptions = {
  anchorScrolling: "enabled",
  onSameUrlNavigation: "reload",
  scrollPositionRestoration: "top",
};

@NgModule({
  providers: [
    {
      provide: externalUrlProvider,
      useValue: (route: ActivatedRouteSnapshot) => {
        const externalUrl = route.paramMap.get("externalUrl");
        window.open(externalUrl, "_blank");
      },
    },
    {
      provide: deactivateGuard,
      useValue: () => {
        console.log("Guard function is called!");

        return false;
      },
    },
  ],
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
